import React, { useState, useEffect, lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Grid,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import MainSetting from "./LComponents/MainSetting/MainSetting";
import Category from "../IndexBank/LComponents/Category/Category";
import MeasurementUnit from "../IndexBank/LComponents/MeasurementUnit/MeasurementUnit";
import ReportingPeriod from "../IndexBank/LComponents/ReportingPeriod/ReportingPeriod";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Setting: React.FC = function () {
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid container   >
      <Grid item xs={12} md={12}  >
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="تنظیمات" {...a11yProps(0)} style={{color:'black', fontWeight:'700'}}/>
              <Tab label="دسته بندی" {...a11yProps(1)} style={{color:'black', fontWeight:'700'}}/>
              <Tab label="واحد های سنجش" {...a11yProps(2)} style={{color:'black', fontWeight:'700'}}/>
              <Tab label="منطق گزارش دهی" {...a11yProps(3)} style={{color:'black', fontWeight:'700'}}/>
              
            </Tabs>
          </Box>
          
          <CustomTabPanel value={value} index={0}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <MainSetting
          />
            </Suspense>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <Category
          />
            </Suspense>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <MeasurementUnit
          />
            </Suspense>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <ReportingPeriod
          />
            </Suspense>
          </CustomTabPanel>

        </Box>
      </Grid>
      </Grid>
    </>
  );
};

export default Setting;
